import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_workspace",
  "use": "icon_workspace-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon_workspace\"><style></style><path d=\"M18 4H2V2h16v2zm0 1h-3v3h3V5zm0 4h-3v3h3V9zm-4-4h-3v4h3V5zm0 5h-3v3h3v-3zm-4-5H7v5h3V5zm0 6H7v4h3v-4zM6 5H3v5h3V5z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" id=\"icon_workspace_Layer_3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol